import { css } from '@emotion/react';

const iokaStyles = {
    container: css({
        height: '650px',
    }),
};

export default iokaStyles;
